import angular from 'angular';
import companyAddFormComponent from './company-add-form.component';

export default angular.module('components.app.admin.company.company-add-form', [])
  .component('companyAddForm', companyAddFormComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/company/company-add-form/company-add-form.module.js